import React from 'react';
import NavBar from '@/components/NavBar';
import AnalyticsDashboard from '@/components/AnalyticsDashboard';
import { ArrowLeft, BarChart3 } from 'lucide-react';
import { Link, Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useUserRole } from '@/hooks/useUserRole';
import SEOHead from '@/components/SEOHead';

const Analytics = () => {
  const { isAdmin, loading } = useUserRole();

  if (loading) {
    return (
      <div className="min-h-screen bg-background">
        <NavBar />
        <div className="container mx-auto px-4 py-8">
          <div className="text-center animate-pulse">Verificando permisos...</div>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/auth" replace />;
  }

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Analytics - CompresorJPEG"
        description="Dashboard de analytics del compresor de imágenes."
        canonical="https://compresorjpeg.com/analytics"
        noindex={true}
      />
      <NavBar />
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-4 mb-8">
            <Link to="/configuration">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Configuración
              </Button>
            </Link>
            <div>
              <h1 className="text-3xl font-bold text-foreground flex items-center gap-2">
                <BarChart3 className="h-8 w-8 text-purple-600" />
                Analytics
              </h1>
              <p className="text-muted-foreground mt-1">Datos anónimos de uso y conversión</p>
            </div>
          </div>
          <AnalyticsDashboard />
        </div>
      </div>
    </div>
  );
};

export default Analytics;
